import { ChannelNames } from '..';
import { ChainEvent } from '../channels/ChainEvent';

type ChainableMessagePayload = {
  onModalCloseEvent: ChainEvent<ChannelNames>;
};

export const isChainableMessagePayload = (
  data: unknown
): data is ChainableMessagePayload => {
  return (
    !!data &&
    typeof data === 'object' &&
    !!Object.getOwnPropertyDescriptor(data, 'onModalCloseEvent')
  );
};
